/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2bcc02335609cd348572f540802108f0b3f4afb1";
